export default __webpack_public_path__ + "static/media/MembershipsPlaceholder.b6e6f5c0.png";